import r from"./_arrayLikeKeys.js";import a from"./_baseKeys.js";import e from"./isArrayLike.js";var o=r,s=a,i=e;var t=function(r){return i(r)?o(r):s(r)};export{t as default};
//# sourceMappingURL=keys.js.map
